<ng-template #detailsToggle>
  <button type="button"
          class="shrink-0 p-1 -m-1 leading-none text-surface-900 hover:text-primary-600 cursor-pointer"
          [attr.aria-label]="toggleLabel()"
          [pTooltip]="toggleLabel()"
          tooltipPosition="left"
          (click)="toggleDetails()"
          data-testid="template-summary-toggle">
    <i class="fa-regular fa-sidebar-flip text-xl"></i>
  </button>
</ng-template>

@if (!showDetails()) {
  @if (!template()) {
    <p-card>
      <ng-container [ngTemplateOutlet]="detailsToggle"></ng-container>
    </p-card>
  } @else {
    <div class="w-full self-stretch p-4 bg-primary-50 rounded-xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] inline-flex flex-col justify-start items-start gap-5 overflow-hidden">
      <ng-container [ngTemplateOutlet]="detailsToggle"></ng-container>
    </div>
  }
} @else if (!template()) {
  <p-card class="w-115 max-w-full">
    <div class="w-full h-full flex flex-col px-2">
      <div class="w-full flex justify-between items-center gap-3">
        <div class="text-Surface-900 text-base font-semibold font-['Inter'] leading-5">Template Summary</div>
        <ng-container [ngTemplateOutlet]="detailsToggle"></ng-container>
      </div>
      <div class="w-full flex justify-center py-14">
        <div class="text-center text-datatable-row-color text-sm font-normal font-['Inter'] leading-5">Select a template to view a summary.</div>
      </div>
    </div>
  </p-card>
} @else {
  <div class="w-115 max-w-full self-stretch p-4 bg-primary-50 rounded-xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex flex-col gap-4 min-w-[250px]"
       data-testid="template-summary">
    <div class="w-full flex justify-between items-center gap-3">
      <div class="text-Surface-900 text-base font-semibold font-['Inter'] leading-6">Template Summary</div>
      <ng-container [ngTemplateOutlet]="detailsToggle"></ng-container>
    </div>
    <div class="w-full h-px bg-surface-200"></div>

    <div class="flex flex-col gap-4 px-2.5 pt-1">
      <div class="text-Surface-900 text-sm font-['Inter'] leading-5">
        <span class="font-semibold">{{ template()!.name }}@if (template()?.creation?.created) { -}</span>
        @if (template()?.creation?.created) {
          <span> Created {{ template()?.creation?.created | date:'dd/MM/yyyy' }}</span>
        }
      </div>

      <div class="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 pl-3.5 text-sm leading-5 font-['Inter']">
        <div class="font-semibold text-surface-700">Primary Traveller</div>
        <div class="text-surface-700">{{ template()!.primaryTraveller?.name ?? '' }}</div>
        <div class="font-semibold text-surface-700">Secondary Travellers</div>
        <div class="text-surface-700">{{ secondaryTravellers() }}</div>
        <div class="font-semibold text-surface-700">Purpose</div>
        <div class="text-surface-700">{{ template()!.purpose ?? '' }}</div>
        <div class="font-semibold text-surface-700">Destinations</div>
        <div class="text-surface-700">{{ destinations() }}</div>
        <div class="font-semibold text-surface-700">Trip Duration</div>
        <div class="text-surface-700">{{ tripDuration() }}</div>
        <div class="font-semibold text-surface-700">Project Code</div>
        <div class="text-surface-700">{{ template()!.project?.code ?? '' }}</div>
      </div>

      <div class="text-sm leading-tight text-surface-700 font-['Inter']">
        Select <b>Create TA from Template</b> below to start a new TA based on this template.
      </div>

      <div class="flex justify-center items-center gap-4 py-2">
        <span [pTooltip]="createDisabledMessage()" tooltipPosition="left">
          <p-button label="Create TA from Template"
                    size="small"
                    [disabled]="createDisabled()"
                    (onClick)="createTa.emit()"
                    data-testid="template-summary-create-ta"></p-button>
        </span>
        <p-button label="Edit Template"
                  size="small"
                  [text]="true"
                  (onClick)="editTemplate.emit()"
                  data-testid="template-summary-edit"></p-button>
      </div>
    </div>
  </div>
}
